import { SecretsManagerException } from './exception'

export const URL_SECRET_MANAGER = 'http://localhost:2773/secretsmanager/get'

export const AWSSecretsManager = async (secretName: string) => {
	try {
		const response = await fetch(
			`${URL_SECRET_MANAGER}?secretId=${secretName}`,
			{
				headers: {
					// eslint-disable-next-line turbo/no-undeclared-env-vars
					'X-Aws-Parameters-Secrets-Token': process.env
						.AWS_SESSION_TOKEN as string,
				},
				next: {
					revalidate: 0,
				},
			}
		)

		if (response.ok) {
			const json = await response.json()
			return { credentials: JSON.parse(json.SecretString) }
		}
		throw new Error(response.statusText)
	} catch {
		throw new SecretsManagerException.Generic()
	}
}
